import { render, staticRenderFns } from "./GSelectLivro.vue?vue&type=template&id=566ff3c5"
import script from "./GSelectLivro.vue?vue&type=script&lang=js"
export * from "./GSelectLivro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports